export default "__VITE_ASSET__ecXSyQth__"